import { generateAPI } from "../api.generator";
import { SupportTicket } from "../../types/ticket";

// POST /support-ticket/mine/:id/read — clear the customer's unread on a ticket.
export const markMyTicketRead = generateAPI<{ params: string }, SupportTicket>(
  "post",
  "support-ticket/mine"
);
